import React, {Component} from 'react';
import TestSend from '../templates/testSend';

class statisticPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data:    [],
            message: {},
        };
    }

    changeState(data) {
        this.setState(data)
    }

    render() {
        return (
            <div className="">
                <TestSend {...this}/>
            </div>
        );
    }
}

export default statisticPage;